export default __webpack_public_path__ + "static/media/BM.fa61c742.png";